export interface SettingConfigOptions {
    apnoType: ('PATENT_TYPE' | 'PBD')[];
    authorityType: string[];
    dateType: ('Latest' | 'Oldest')[];
    documentType: ('APD' | 'PBD')[];
    fieldsList: ('ALL' | 'APNO_FACET' | 'FAMILY_ID' | 'INPADOC_FAMILY_ID' | 'EXTEND_FAMILY')[];
    languageList: ("default" | "translation")[];
    patentType: ('A' | 'B')[];
    searchCollapseType: ('AUTHORITY' | 'APD'| 'PBD' | 'PATENT_TYPE' | 'SCORE')[];
    stemList: boolean[];
    tagFamilyList: ('all' | 'CN' | 'DE' | 'EP' | 'FR' | 'GB' | 'JP' | 'KR' | 'RU' | 'US' | 'WO')[]
    tagFamilyTypeList: ('EXTEND' | 'DOCDB' | 'INPADOC')[];
}

/**
 * 根据搜索模式设置搜索配置
 * @param searchMode
 * @returns 一个函数，接受一个搜索配置，返回一个新的搜索配置
 */
export const formatSettingConfig = (searchMode: 'publication' | 'family') => (config: SettingConfigOptions) => {
    if (searchMode === 'family') {
        const { tagFamilyTypeList, fieldsList, searchCollapseType, ...rest } = config;

        return {
            tagFamilyTypeList: [...tagFamilyTypeList.slice(0, 1)],
            fieldsList: [...fieldsList.slice(0, 1), ...fieldsList.slice(-1)],
            searchCollapseType: [...searchCollapseType.slice(0, 4)],
            ...rest,
        };
    }

    return config;
}
